export const COUNTDOWN = 3;
export const TIMER = 0;
export const ONE_SECOND = 1000;
export const TEN_SECONDS = ONE_SECOND * 10;

export const MAX_SAMPLE_RATE = 96000;
export const DEFAULT_SAMPLE_RATE = 48000;
export const MIN_SAMPLE_RATE = 16000;

export const MAX_ALLOWED_FILE_SIZE = 5242880; // 5MB

export const STEP = 0.1;
